import { css, Global } from '@emotion/react';

import { appColor } from '~/modules/theme';

export default function GlobalStyles() {
  return (
    <Global
      styles={css`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

        *,
        *:before,
        *:after {
          box-sizing: border-box;
        }

        html {
          -webkit-font-smoothing: antialiased;
          height: 100%;
        }

        body {
          font-family: 'Poppins', sans-serif;
          font-size: 16px; /* stylelint-disable unit-disallowed-list */
          margin: 0;
          min-height: 100dvh;
          padding: 0;
        }

        img {
          height: auto;
          max-width: 100%;
        }

        a {
          color: ${appColor};

          &.disabled {
            pointer-events: none;
          }
        }

        button {
          appearance: none;
          background-color: transparent;
          border: 0;
          cursor: pointer;
          display: inline-block;
          font-family: inherit;
          line-height: 1;
          padding: 0;
        }
      `}
    />
  );
}
